import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { ErrorAlertModule } from '@/store/modules/errors';
import { getLanguages } from '@/api/main';
import { errorHandler } from '@/utils/common';

export interface ILanguagesState {
  entities: string[];
  loading: boolean;
  loaded: boolean;
}

@Module({ dynamic: true, store, name: 'languages', namespaced: true })
class Languages extends VuexModule implements ILanguagesState {
  entities: string[] = [];
  loaded = false;
  loading = false;

  @Mutation
  pending() {
    ErrorAlertModule.setErrorAlert('');
    this.entities = [];
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  fulfilled(data: string[]) {
    this.loading = false;
    this.loaded = true;
    this.entities = data;
  }

  @Mutation
  rejected(error: unknown) {
    errorHandler(error);
    this.loading = false;
    this.loaded = false;
  }

  @Action
  async fetch() {
    this.pending();

    try {
      const data = await getLanguages();
      this.fulfilled(data);
    } catch (error) {
      this.rejected(error);
    }
  }
}

export const LanguagesModule = getModule(Languages);
